
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { recordUsage, sortCategoriesByUsage } from "@/lib/services/usageFrequencyService";

interface ProductFormBasicInfoProps {
  name: string;
  setName: (name: string) => void;
  description: string;
  setDescription: (description: string) => void;
  category: "ostomy" | "medicine" | "other";
  setCategory: (category: "ostomy" | "medicine" | "other") => void;
}

const ProductFormBasicInfo = ({
  name,
  setName,
  description,
  setDescription,
  category,
  setCategory,
}: ProductFormBasicInfoProps) => {
  const categories = ['ostomy', 'medicine', 'other'];
  const sortedCategories = sortCategoriesByUsage(categories);

  const handleCategoryChange = (value: "ostomy" | "medicine" | "other") => {
    recordUsage('category', value);
    setCategory(value);
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="name">Name *</Label>
        <Input
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g., Coloplast Sensura Mio"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="description">Description (optional)</Label>
        <Textarea
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Add any additional details"
          className="min-h-[80px]"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="category">Category</Label>
        <Select
          value={category}
          onValueChange={handleCategoryChange}
        >
          <SelectTrigger id="category">
            <SelectValue placeholder="Select category" />
          </SelectTrigger>
          <SelectContent className="bg-background border border-border shadow-lg z-50">
            {sortedCategories.map(cat => (
              <SelectItem key={cat} value={cat}>
                {cat.charAt(0).toUpperCase() + cat.slice(1)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default ProductFormBasicInfo;
